export default __webpack_public_path__ + "static/media/socket.aa27363b.svg";